import { render, staticRenderFns } from "./MonksPrimaryButton.vue?vue&type=template&id=5f339ff5&scoped=true"
import script from "./MonksPrimaryButton.vue?vue&type=script&lang=js"
export * from "./MonksPrimaryButton.vue?vue&type=script&lang=js"
import style0 from "./MonksPrimaryButton.scss?vue&type=style&index=0&id=5f339ff5&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f339ff5",
  null
  
)

export default component.exports